"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.RemovableFilterTrigger = void 0;
var react_1 = __importDefault(require("react"));
var component_library_1 = require("@kaizen/component-library");
var clear_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/clear.icon.svg"));
var draft_tooltip_1 = require("@kaizen/draft-tooltip");
var FilterTriggerButton_1 = require("../FilterTriggerButton");
var RemovableFilterTrigger_module_scss_1 = __importDefault(require("./RemovableFilterTrigger.module.scss"));
var RemovableFilterTrigger = function (_a) {
    var onRemove = _a.onRemove, classNameOverride = _a.classNameOverride, filterTriggerProps = __rest(_a, ["onRemove", "classNameOverride"]);
    var removeButtonLabel = "Remove filter - ".concat(filterTriggerProps.label);
    return (react_1["default"].createElement("div", { className: "".concat(RemovableFilterTrigger_module_scss_1["default"].trigger, " ").concat(classNameOverride) },
        react_1["default"].createElement(FilterTriggerButton_1.FilterTriggerButton, __assign({ classNameOverride: RemovableFilterTrigger_module_scss_1["default"].triggerButton }, filterTriggerProps)),
        react_1["default"].createElement("div", { className: RemovableFilterTrigger_module_scss_1["default"].divider }),
        react_1["default"].createElement(draft_tooltip_1.Tooltip, { text: removeButtonLabel, position: "below" },
            react_1["default"].createElement("button", { type: "button", className: RemovableFilterTrigger_module_scss_1["default"].removeButton, "aria-label": removeButtonLabel, onClick: onRemove },
                react_1["default"].createElement(component_library_1.Icon, { icon: clear_icon_svg_1["default"], role: "presentation" })))));
};
exports.RemovableFilterTrigger = RemovableFilterTrigger;
exports.RemovableFilterTrigger.displayName = "RemovableFilterTrigger";
//# sourceMappingURL=RemovableFilterTrigger.js.map